// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * RightDockRail Styles (DOCK_SSOT_B3 — RD-03a)
 * Shell dùng chung single↔multi: grip 10px + flyout trượt + pinned in-flow +
 * mobile bottomsheet. Rule dời NGUYÊN VĂN từ multicharts-layout.module.css
 * (audit O-1: dời theo rule dock-scoped; \`.workspaceBody/.workspaceMainCol/
 * .charts\` Ở LẠI file cũ — consumer multi).
 */

/* F1 autohide (giống hệt drawing toolbar shell): wrapper 10px = grip zone
   thường trực; flyout trượt thuần CSS (:hover/:focus-within hoặc class Open
   khi drawer mở). Không JS timer. z-index: PHẢI nổi trên bottom panel
   (--vnsc-z-bottom-panel = 40) trong cùng stacking context .workspaceBody
   (z-index 10) — nếu thấp hơn, panel vẽ đè nửa dưới dock và drawer mất
   hit-test (bug user 2026-10-18). Mirror single: dock host desktop z 48
   (right-sidebar-dock.module.css:10, token --vnsc-z-sidebar). Mobile giữ 20
   (C7/A12 — xem khai báo tường minh trong block @media bên dưới). */
.OyAj7UmvRTGgDoSXveQE {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 10px;
  z-index: var(--vnsc-z-sidebar, 48);
  pointer-events: auto;
}

/* Grip dots (mirror .vnsc-drawing-toolbar-handle::before). */
.OyAj7UmvRTGgDoSXveQE::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3px;
  height: 3px;
  border-radius: 999px;
  background: var(--vnsc-text-secondary);
  box-shadow:
    0 -6px 0 var(--vnsc-text-secondary),
    0 6px 0 var(--vnsc-text-secondary);
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.CxcXMtLbussBOfTFpcpg {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  transform: translateX(100%);
  /* S1: flyout ẩn PHẢI visibility:hidden — kẻo tạo scrollable overflow làm
     scrollIntoView/keyboard-Tab lệch cả app (đã đo scrollLeft=24 trên root). */
  visibility: hidden;
  transition: transform 0.2s ease, visibility 0s linear 0.2s;
}

.OyAj7UmvRTGgDoSXveQE:hover .CxcXMtLbussBOfTFpcpg,
.OyAj7UmvRTGgDoSXveQE:focus-within .CxcXMtLbussBOfTFpcpg,
.iF1jaeFTuKsFbmRrphLd .CxcXMtLbussBOfTFpcpg {
  transform: translateX(0);
  visibility: visible;
  transition: transform 0.2s ease, visibility 0s;
}

/* W3-fix: descendant (không phải >) — Suspense/host render fragment nên
   .dock là cháu (không phải con trực tiếp); \`>\` làm nút mất hit-test và
   elementFromPoint rơi xuống header bên dưới (đã đo thực tế). */
.OyAj7UmvRTGgDoSXveQE * {
  pointer-events: auto;
}

/* E2: pinned dock in-flow (grid co lại như singlechart + toolbar-locked). */
._BDH4IaHB092UbqcARqz {
  position: static;
  width: auto;
  flex-shrink: 0;
  display: flex;
}

._BDH4IaHB092UbqcARqz::before {
  display: none;
}

/* F2: flyout display:contents ở pinned — chuỗi height:100% của .dock được giữ
   (row definite → wrapper stretch definite → dock bounded, scroll nội bộ).
   Để flyout static height:auto sẽ làm .dock height:100% vô định → content
   height 1301px tràn xuống bottom panel (đã đo runtime). */
._BDH4IaHB092UbqcARqz .CxcXMtLbussBOfTFpcpg {
  display: contents;
  visibility: visible;
}

/* W3-mobile: bottomsheet của host là absolute (out-of-flow) → wrapper
   shrink-fit về width 0, dock tràn ra ngoài viewport (đã đo: strip x=399-443
   ở viewport 400px). Ép wrapper full-bleed bottom để sheet có containing
   block đúng. Desktop không đổi. */
@media (max-width: 767px) {
  .OyAj7UmvRTGgDoSXveQE {
    left: 0;
    right: 0;
    top: auto;
    bottom: 0;
    width: auto;
    /* Giữ nguyên hành vi bottomsheet cũ (C7/A12): desktop mới nâng lên
       token sidebar 48; mobile vẫn dưới panel theo thiết kế bottomsheet. */
    z-index: 20;
  }
  .OyAj7UmvRTGgDoSXveQE::before {
    display: none;
  }
  /* Mobile không hover: flyout thường trực (strip + bottomsheet như W3). */
  .CxcXMtLbussBOfTFpcpg {
    position: static;
    transform: none;
    visibility: visible;
  }
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/right-dock-rail.module.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;;;;;;;oEAOoE;AACpE;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC;;sCAEoC;EACpC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B;+EAC6E;EAC7E,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;;;EAGE,wBAAwB;EACxB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;gEAEgE;AAChE;EACE,oBAAoB;AACtB;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;2DAG2D;AAC3D;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;mCAGmC;AACnC;EACE;IACE,OAAO;IACP,QAAQ;IACR,SAAS;IACT,SAAS;IACT,WAAW;IACX;2EACuE;IACvE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA,yEAAyE;EACzE;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":["/**\r\n * RightDockRail Styles (DOCK_SSOT_B3 — RD-03a)\r\n * Shell dùng chung single↔multi: grip 10px + flyout trượt + pinned in-flow +\r\n * mobile bottomsheet. Rule dời NGUYÊN VĂN từ multicharts-layout.module.css\r\n * (audit O-1: dời theo rule dock-scoped; `.workspaceBody/.workspaceMainCol/\r\n * .charts` Ở LẠI file cũ — consumer multi).\r\n */\r\n\r\n/* F1 autohide (giống hệt drawing toolbar shell): wrapper 10px = grip zone\r\n   thường trực; flyout trượt thuần CSS (:hover/:focus-within hoặc class Open\r\n   khi drawer mở). Không JS timer. z-index: PHẢI nổi trên bottom panel\r\n   (--vnsc-z-bottom-panel = 40) trong cùng stacking context .workspaceBody\r\n   (z-index 10) — nếu thấp hơn, panel vẽ đè nửa dưới dock và drawer mất\r\n   hit-test (bug user 2026-10-18). Mirror single: dock host desktop z 48\r\n   (right-sidebar-dock.module.css:10, token --vnsc-z-sidebar). Mobile giữ 20\r\n   (C7/A12 — xem khai báo tường minh trong block @media bên dưới). */\r\n.workspaceDock {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 10px;\r\n  z-index: var(--vnsc-z-sidebar, 48);\r\n  pointer-events: auto;\r\n}\r\n\r\n/* Grip dots (mirror .vnsc-drawing-toolbar-handle::before). */\r\n.workspaceDock::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 3px;\r\n  height: 3px;\r\n  border-radius: 999px;\r\n  background: var(--vnsc-text-secondary);\r\n  box-shadow:\r\n    0 -6px 0 var(--vnsc-text-secondary),\r\n    0 6px 0 var(--vnsc-text-secondary);\r\n  transform: translate(-50%, -50%);\r\n  pointer-events: none;\r\n}\r\n\r\n.workspaceDockFlyout {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  display: flex;\r\n  transform: translateX(100%);\r\n  /* S1: flyout ẩn PHẢI visibility:hidden — kẻo tạo scrollable overflow làm\r\n     scrollIntoView/keyboard-Tab lệch cả app (đã đo scrollLeft=24 trên root). */\r\n  visibility: hidden;\r\n  transition: transform 0.2s ease, visibility 0s linear 0.2s;\r\n}\r\n\r\n.workspaceDock:hover .workspaceDockFlyout,\r\n.workspaceDock:focus-within .workspaceDockFlyout,\r\n.workspaceDockOpen .workspaceDockFlyout {\r\n  transform: translateX(0);\r\n  visibility: visible;\r\n  transition: transform 0.2s ease, visibility 0s;\r\n}\r\n\r\n/* W3-fix: descendant (không phải >) — Suspense/host render fragment nên\r\n   .dock là cháu (không phải con trực tiếp); `>` làm nút mất hit-test và\r\n   elementFromPoint rơi xuống header bên dưới (đã đo thực tế). */\r\n.workspaceDock * {\r\n  pointer-events: auto;\r\n}\r\n\r\n/* E2: pinned dock in-flow (grid co lại như singlechart + toolbar-locked). */\r\n.workspaceDockPinned {\r\n  position: static;\r\n  width: auto;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n}\r\n\r\n.workspaceDockPinned::before {\r\n  display: none;\r\n}\r\n\r\n/* F2: flyout display:contents ở pinned — chuỗi height:100% của .dock được giữ\r\n   (row definite → wrapper stretch definite → dock bounded, scroll nội bộ).\r\n   Để flyout static height:auto sẽ làm .dock height:100% vô định → content\r\n   height 1301px tràn xuống bottom panel (đã đo runtime). */\r\n.workspaceDockPinned .workspaceDockFlyout {\r\n  display: contents;\r\n  visibility: visible;\r\n}\r\n\r\n/* W3-mobile: bottomsheet của host là absolute (out-of-flow) → wrapper\r\n   shrink-fit về width 0, dock tràn ra ngoài viewport (đã đo: strip x=399-443\r\n   ở viewport 400px). Ép wrapper full-bleed bottom để sheet có containing\r\n   block đúng. Desktop không đổi. */\r\n@media (max-width: 767px) {\r\n  .workspaceDock {\r\n    left: 0;\r\n    right: 0;\r\n    top: auto;\r\n    bottom: 0;\r\n    width: auto;\r\n    /* Giữ nguyên hành vi bottomsheet cũ (C7/A12): desktop mới nâng lên\r\n       token sidebar 48; mobile vẫn dưới panel theo thiết kế bottomsheet. */\r\n    z-index: 20;\r\n  }\r\n  .workspaceDock::before {\r\n    display: none;\r\n  }\r\n  /* Mobile không hover: flyout thường trực (strip + bottomsheet như W3). */\r\n  .workspaceDockFlyout {\r\n    position: static;\r\n    transform: none;\r\n    visibility: visible;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspaceDock": `OyAj7UmvRTGgDoSXveQE`,
	"workspaceDockFlyout": `CxcXMtLbussBOfTFpcpg`,
	"workspaceDockOpen": `iF1jaeFTuKsFbmRrphLd`,
	"workspaceDockPinned": `_BDH4IaHB092UbqcARqz`
};
export default ___CSS_LOADER_EXPORT___;
